import React, { useState, useEffect, useContext } from "react";
import { Table, Button, Tooltip } from "antd";
import { PAGE_LENGTH } from "../../config";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { UserAddOutlined } from "@ant-design/icons";

import {
  getUserInfo,
  getPartialPhoneNumber,
  getSubscriptionUserInfo,
} from "../../utils/utils";

import {
  submitLead,
  resetLead,
  storeSelectedColleagues,
  getEmployeeViewableStatusUpdate,
  getEmployeeList,
} from "../../actionCreator/executiveDetailsActionCreator";

import TrialModal from "../../common/TrialModal";
import { AuthContext } from "../../context/AuthContext";
import CopyText from "../web2lead/CopyText";
import EmailForm from "../../common/EmailForm";
import copy from "../../assets/images/webToLead/copy.png";
import emailSync from "../../assets/svg/icons/send.svg";
import { useAlert } from "../../context/AlertProvider";
import addedToLead from "../../assets/svg/added-to-lead.svg";
import viewEmail from "../../assets/svg/view-email.svg";
import viewEmailChecked from "../../assets/svg/view-email-checked.svg";
import mobile from "../../assets/svg/mobile.svg";
import mobileChecked from "../../assets/svg/mobile-checked.svg";
import CustomPagination from "../../common/CustomPagination";

const KeyExecutives = () => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const { id: empId } = useParams();
  const { isAuthenticated, isEmailSetupView } = useContext(AuthContext);
  const employeeList = useSelector(
    (state) => state.executiveDetailsReducer.employeeList,
  );
  const submitLeadRes = useSelector(
    (state) => state.executiveDetailsReducer?.executiveLeads,
  );
  const getLeadsData = useSelector(
    (state) => state.executiveDetailsReducer?.getExecutiveLead,
  );
  const getEmployeeViewableData1 = useSelector(
    (state) => state.executiveDetailsReducer?.executiveEmployeeViewableStatus,
  );

  const executiveDetails = useSelector(
    (state) => state.executiveDetailsReducer.executiveDetails,
  );
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeIdsData, setEmployeeIdsData] = useState([]);
  const [openModal, setOpenModal] = useState({
    info: null,
    open: false,
  });
  const [addToLeads, setAddToLeads] = useState(0);
  const [showEmail, setShowEmail] = useState({});
  const [showPhone, setShowPhone] = useState({});
  const [employeeViewableData, setEmployeeViewableData] = useState({});

  const navigate = useNavigate();

  useEffect(() => {
    setEmployeeViewableData(getEmployeeViewableData1);
  }, [getEmployeeViewableData1]);

  const updateEmailStatus = async (showEmail, row) => {
    setShowEmail({ ...showEmail, [row.id]: true });
    row.pageFor = 2;
    row.executiveDetailId = executiveDetails?.id;
    const res = await dispatch(getEmployeeViewableStatusUpdate("Email", row));
    if (res?.status === 400) {
      showAlert("error", res?.title);
    }
  };

  const updatePhoneStatus = async (showPhone, row) => {
    setShowPhone({ ...showPhone, [row.id]: true });
    row.pageFor = 2;
    row.executiveDetailId = executiveDetails?.id;
    const res = await dispatch(getEmployeeViewableStatusUpdate("Mobile", row));
    if (res?.status === 400) {
      showAlert("error", res?.title);
    }
  };

  const getDetails = (id, name) => {
    let cname = name.replaceAll(" ", "-", name);
    navigate(`/executive-details/${id}/${cname}`);
  };
  const columns = [
    {
      title: "Executive Name",
      dataIndex: "fullname",
      fixed: "left",
      render: (text, row) => {
        return (
          <>
            <span
              className="namecol"
              onClick={() => getDetails(`${row?.id}`, `${row?.fullname}`)}
            >
              <Tooltip title={row.fullname}>
                {row.fullname?.length > 15
                  ? `${row.fullname?.substring(0, 15)}...`
                  : row.fullname}
              </Tooltip>
            </span>
          </>
        );
      },
    },
    {
      title: "Designation",
      dataIndex: "title",
      render: (record) => {
        return (
          <Tooltip title={record}>
            {record?.length > 15 ? `${record?.substring(0, 15)}...` : record}
          </Tooltip>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "emailId",
      render: (text, row) => {
        let checkLeadSubmitted = row?.leads?.isLead;
        return isAuthenticated ? (
          <>
            <div
              className={`tw-flex tw-items-center tw-gap-3 ${showEmail[row.key] && row.key === employeeViewableData?.id && "tw-justify-between"}`}
            >
              {showEmail[row.key] && row.key === employeeViewableData?.id ? (
                <>
                  <Tooltip title={employeeViewableData?.emailId}>
                    <span>
                      {employeeViewableData?.emailId?.length > 12
                        ? `${employeeViewableData?.emailId.substring(0, 10)}...`
                        : employeeViewableData?.emailId}
                    </span>
                  </Tooltip>
                  <div className="tw-bg-white tw-border tw-border-solid tw-border-border-secondary tw-rounded-lg tw-flex tw-items-center tw-p-1">
                    <CopyText
                      text={employeeViewableData?.emailId}
                      content={
                        <Tooltip title="Copy Email">
                          <img
                            src={copy}
                            alt=""
                            className="cursor-pointer tw-h-[25px] tw-w-[25px] tw-p-[5px] tw-max-w-[25px]"
                          />
                        </Tooltip>
                      }
                    />

                    {isEmailSetupView && (
                      <>
                        <div className="tw-w-[1px] tw-h-[22px] tw-bg-[#C7C7CC] tw-mx-1.5 tw-shrink-0" />
                        <EmailForm
                          recipientEmail={employeeViewableData?.emailId}
                          empId={employeeViewableData?.id}
                          payload={employeeViewableData}
                          convertToLead={!row?.leads?.isLead}
                          onConvertToLead={() =>
                            postLeads(row?.leads, checkLeadSubmitted)
                          }
                        >
                          <Tooltip title="Send Email">
                            <div className="d-flex align-items-center justify-content-center">
                              <img
                                src={emailSync}
                                alt=""
                                className="tw-cursor-pointer tw-h-[23px] tw-w-[23px] tw-p-[5px] tw-max-w-[23px]"
                              />
                            </div>
                          </Tooltip>
                        </EmailForm>
                      </>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <span
                    className="white-space-nowrap cursor-pointer"
                    onClick={() => updateEmailStatus(showEmail, row)}
                  >
                    View Email{" "}
                  </span>
                  <img
                    src={
                      row?.directDial?.isdownloadedEmail
                        ? viewEmailChecked
                        : viewEmail
                    }
                    alt=""
                    className="cursor-pointer"
                    onClick={() => updateEmailStatus(showEmail, row)}
                  />
                </>
              )}
            </div>
          </>
        ) : (
          <div
            className="  btn iconemail emails"
            onClick={() => openInfoModel()}
          ></div>
        );
      },
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNo",
      render: (text, row) => {
        const number = getPartialPhoneNumber(text);
        return (
          <Tooltip title={number}>
            {number?.length > 12 ? `${number?.substring(0, 12)}...` : number}
          </Tooltip>
        );
      },
    },
    {
      title: "Direct Dial/Mobile    ",
      dataIndex: "directDial",
      render: (record, row) => {
        return isAuthenticated ? (
          <>
            {row?.leads?.phoneNo && row?.leads?.phoneNo !== "" ? (
              <>
                {showPhone[row.id] && row.id === employeeViewableData?.id ? (
                  <div className="d-flex align-items-center gap-10">
                    <Tooltip title={employeeViewableData?.phoneNo}>
                      <span className="phoneValue fs-12 pl-1">
                        {employeeViewableData?.phoneNo}
                      </span>
                    </Tooltip>
                    <div className="email-grp-btn tw-px-[3px]">
                      <CopyText
                        text={employeeViewableData?.phoneNo}
                        content={
                          <Tooltip title="Copy Mobile No.">
                            <img
                              src={copy}
                              alt=""
                              className="cursor-pointer tw-h-[25px] tw-w-[25px] tw-p-[5px] tw-max-w-[25px]"
                            />
                          </Tooltip>
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <img
                    src={
                      row?.directDial?.isdownloadedMobile
                        ? mobileChecked
                        : mobile
                    }
                    alt=""
                    onClick={() => updatePhoneStatus(showPhone, row)}
                  />
                )}
              </>
            ) : (
              <>-</>
            )}
          </>
        ) : (
          <span className=" btn mobile" onClick={() => openInfoModel()}></span>
        );
      },
    },
    {
      title: "",
      dataIndex: "leads",
      render: (record, row) => {
        let checkLeadSubmitted = row?.leads?.isLead;
        return isAuthenticated ? (
          <Button
            type="text"
            onClick={() => postLeads(record, checkLeadSubmitted)}
          >
            {checkLeadSubmitted ? (
              <Tooltip title="Added to lead">
                <img src={addedToLead} alt="" />
              </Tooltip>
            ) : (
              <Tooltip title="Add to lead">
                <UserAddOutlined className="heading18px" />
              </Tooltip>
            )}
          </Button>
        ) : (
          <Button type="text" onClick={() => openInfoModel()}>
            <Tooltip title="Add to lead">
              <UserAddOutlined className="heading18px" />
            </Tooltip>
          </Button>
        );
      },
    },
  ];

  const postLeads = async (record, isLeadSubmit) => {
    const { id } = getUserInfo();
    const { id: accountId } = getSubscriptionUserInfo();
    let leadPayload = {
      accountId: accountId,
      firstname: record.firstname,
      lastname: record.lastname,
      fullname: record.fullname,
      title: record.title,
      client: record.client,
      emailId: record.emailId,
      phoneNo: record.phoneNo,
      bio: record.bio,
      description: record.description,
      userId: id,
      employeeId: record.id,
      address: record?.company?.address,
      companyId: record?.company?.id,
      companyName: record?.company?.name,
      industryId: record?.company?.industry?.id,
      industryText: record?.company?.industry?.name,
      empSizeId: record?.company?.range?.name,
      city: record?.company?.city,
      state: record?.company?.state,
      country: record?.company?.country,
      status: 11,
    };
    //status 11 for new lead
    if (!isLeadSubmit) {
      const res = await dispatch(submitLead(leadPayload, employeeIdsData));
      if (res?.status === 201) {
        dispatch(getEmployeeList(empId, record?.company?.id));
      } else {
        showAlert("error", res);
      }
      setAddToLeads(record.id);
    } else {
      navigate("/lead-details/" + isLeadSubmit);
    }
  };

  const resetLeadsData = () => {
    dispatch(resetLead({}));
    setAddToLeads(0);
  };

  useEffect(() => {
    let data = [];
    let empIdsArr = [];
    employeeList?.forEach((record) => {
      empIdsArr = [...empIdsArr, record.id];
      data = [
        ...data,
        {
          key: record.id,
          id: record.id,
          fullname: record?.fullname
            ? record.fullname
            : record.firstname + " " + record.lastname,
          title: record?.title,
          emailId: record?.emailId,
          phoneNo: record?.company?.phoneNo,
          directDial: record,
          leads: record,
          pageFor: 2,
        },
      ];
    });
    setEmployeeData(data);
    setEmployeeIdsData(empIdsArr);
  }, [employeeList]);

  const openInfoModel = () => {
    if (isAuthenticated) {
      setOpenModal({ info: null, open: false });
    } else {
      setOpenModal({ info: null, open: true });
    }
  };

  const redirectToSignup = () => {
    setOpenModal(false);
    navigate("/signup");
  };

  const closeInfoBeforeLogin = () => {
    setOpenModal(false);
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      dispatch(storeSelectedColleagues(selectedRows));
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User", // Column configuration not to be checked
      name: record.name,
    }),
  };

  return (
    <>
      <Table
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        columns={columns}
        bordered={false}
        dataSource={employeeData}
        className="tw-custom-table tw-custom-table-no-border"
        pagination={false}
      />
      <CustomPagination
        hidePerPage
        hideGoToPage
        noBorder
        total={employeeList?.length}
        pageSize={PAGE_LENGTH}
        onChange={() => {}}
      />

      {openModal?.open && (
        <TrialModal
          openModal={openModal}
          closeModal={closeInfoBeforeLogin}
          redirectToSignup={redirectToSignup}
          redirect={true}
          isSubscriptionMissing
        />
      )}
    </>
  );
};

export default KeyExecutives;
